// @ts-nocheck
import React from "react";
import {
  withStyles,
  Grid,
  Typography,
  createStyles,
  Button,
  TextField,
  InputAdornment,
  IconButton,
} from "@material-ui/core";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import { withRouter, RouterProps } from "react-router";
import withAlertBox, {
  withAlertBoxProps,
} from "../../../../components/src/withAlertBox.Web";
import withToast, {
  withToastProps,
} from "../../../../components/src/withSnackBar.Web";
import withLoader, {
  withLoaderProps,
} from "../../../../components/src/withLoader.Web";
import withDialogBox from "../../../../components/src/withDialog.web";
import { DialogProps } from "../../../../components/src/DialogContext";

export type Props = RouterProps &
  DialogProps &
  withAlertBoxProps &
  withToastProps &
  withLoaderProps & {
    id: string;
  };

export class ApiKeyDialog extends React.Component {
  constructor(props: Props) {
    super(props);
    this.state = { copied: false };
  }

  copyToken = async () => {
    const { token } = this.props.dataToPass;
    try {
      await navigator.clipboard.writeText(token);
      this.setState({ copied: true });
    } catch (error) {
      this.props.showToast({
        type: "error",
        message: "Could not copy. Select the key and copy it manually.",
      });
    }
  };

  closeDialog = () => {
    this.props.onSubmit(null);
  };

  render() {
    const { classes, dataToPass } = this.props;
    return (
      <Grid container className={classes.rootContainer}>
        <Grid item xs={12}>
          <Typography align="center" className={classes.dialogHeading}>
            Your API key
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography className={classes.warning}>
            Copy it now. For your security we only store an encrypted version,
            so this key cannot be shown again. If you lose it, revoke the key
            and generate a new one.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            variant="outlined"
            value={dataToPass.token}
            InputProps={{
              readOnly: true,
              classes: { input: classes.tokenInput },
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={this.copyToken} aria-label="Copy API key">
                    <FileCopyOutlinedIcon color="primary" />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item xs={12} className={classes.copiedContainer}>
          {this.state.copied && (
            <Typography className={classes.copiedText}>
              Copied to clipboard
            </Typography>
          )}
        </Grid>
        <Grid item xs={12} className={classes.buttonContainer}>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            className={classes.doneButton}
            onClick={this.closeDialog}
          >
            Done
          </Button>
        </Grid>
      </Grid>
    );
  }
}

const ApiKeyDialogWithRouter = withRouter(ApiKeyDialog);
const ApiKeyDialogWithToast = withToast(ApiKeyDialogWithRouter);
const ApiKeyDialogWithLoader = withLoader(ApiKeyDialogWithToast);
const ApiKeyDialogWithAlertBox = withAlertBox(ApiKeyDialogWithLoader);
const ApiKeyDialogWithDialogBox = withDialogBox(ApiKeyDialogWithAlertBox);

export default withStyles((theme) =>
  createStyles({
    rootContainer: {
      padding: "1rem",
    },
    dialogHeading: {
      fontSize: "1.35rem",
      fontWeight: "bold",
      color: theme.palette.text.secondary,
      marginBottom: "1.2rem",
      marginTop: "1rem",
    },
    warning: {
      backgroundColor: "#fdf3e0",
      border: "1px solid #f0dcb4",
      borderRadius: "6px",
      color: "#5c421a",
      fontSize: "0.95rem",
      lineHeight: 1.4,
      marginBottom: "1rem",
      padding: "0.75rem",
    },
    tokenInput: {
      fontFamily: "monospace",
      fontSize: "0.95rem",
    },
    copiedContainer: {
      minHeight: "1.5rem",
    },
    copiedText: {
      color: theme.palette.primary.main,
      fontSize: "0.9rem",
    },
    buttonContainer: {
      padding: "0 1.5rem",
    },
    doneButton: {
      margin: "1rem 0px",
    },
  })
)(ApiKeyDialogWithDialogBox);
